import { render, staticRenderFns } from "./BindOk.vue?vue&type=template&id=42a93f68&scoped=true&"
import script from "./BindOk.vue?vue&type=script&lang=js&"
export * from "./BindOk.vue?vue&type=script&lang=js&"
import style0 from "./BindOk.vue?vue&type=style&index=0&id=42a93f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a93f68",
  null
  
)

export default component.exports